import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotContent from './components/HotContent';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '久久在线',
  url: 'https://jiujiuonline.com',
  description: '久久在线是您最值得信赖的在线平台，提供海量优质内容资源，支持随时随地流畅访问。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://jiujiuonline.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '久久在线',
  url: 'https://jiujiuonline.com',
  description: '久久在线是一个综合性在线内容平台，提供视频、资讯、娱乐、科技等八大板块的优质内容。',
  sameAs: [
    'https://weibo.com/jiujiuonline',
    'https://space.bilibili.com/jiujiuonline',
  ],
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: '久久在线是什么平台？', acceptedAnswer: { '@type': 'Answer', text: '久久在线是一个综合性在线内容平台，提供视频、资讯、娱乐、科技、生活、教育、体育、音乐等八大板块的优质内容，支持网页端和移动端随时随地访问。' } },
    { '@type': 'Question', name: '久久在线的内容是否免费观看？', acceptedAnswer: { '@type': 'Answer', text: '久久在线提供大量免费内容资源，用户注册后即可免费观看。部分精品内容可能需要会员权限，但我们始终保持大部分内容免费开放。' } },
    { '@type': 'Question', name: '如何获取久久在线的最新内容更新？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过关注久久在线的微信公众号、微博账号或订阅我们的邮件通讯来获取最新内容更新通知。' } },
    { '@type': 'Question', name: '久久在线的视频支持高清播放吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，久久在线全面支持高清视频播放，最高支持1080P和4K超高清画质。平台采用先进的流媒体技术，确保流畅播放。' } },
    { '@type': 'Question', name: '久久在线可以在哪些设备上使用？', acceptedAnswer: { '@type': 'Answer', text: '久久在线支持多种设备访问，包括电脑（Windows/Mac）、平板（iPad/Android平板）和手机（iOS/Android）。' } },
    { '@type': 'Question', name: '久久在线的内容更新频率如何？', acceptedAnswer: { '@type': 'Answer', text: '久久在线每日更新大量新鲜内容，覆盖八大内容板块。我们的编辑团队全天候工作，确保用户第一时间获取最新内容。' } },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="久久在线 - 随时随地畅享优质内容"
        description="久久在线是您最值得信赖的在线平台，提供海量优质内容资源，支持随时随地流畅访问。覆盖视频、资讯、娱乐、科技、生活、教育、体育、音乐八大板块。"
        keywords="久久在线,久久在线免费观看,久久在线视频,久久在线播放,久久在线资源,久久在线高清,久久在线入口"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20Chinese%20online%20content%20platform%20brand%20visual%20with%20warm%20orange%20and%20cream%20tones%2C%20clean%20minimalist%20design%2C%20digital%20media%20aesthetic%2C%20soft%20gradients%2C%20professional%20editorial%20style&width=1200&height=630&seq=og-home-2026&orientation=landscape"
        jsonLd={[orgJsonLd, homeJsonLd, faqJsonLd]}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotContent />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}